import { gql } from '@apollo/client';

export const ADD_UPDATE_ACCOUNT_STATEMENT = gql`
  mutation addOrUpdateAccountStatement($input: AccountStatementItemInput) {
    addOrUpdateAccountStatement(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_ACCOUNT_STATEMENT_DETAIL = gql`
  mutation addOrUpdateAccountStatementDetail($input: AccountStatementDetailItemInput) {
    addOrUpdateAccountStatementDetail(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const REMOVE_ACCOUNT_STATEMENT_DETAIL = gql`
  mutation deleteAccountStatementDetail($input: DeleteAccountStatementDetailItemInput) {
    deleteAccountStatementDetail(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_ACCOUNT_STATEMENT_INDICATOR = gql`
  mutation addOrUpdateAccountStatementIndicator($input: AccountStatementIndicatorItemInput) {
    addOrUpdateAccountStatementIndicator(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const REMOVE_ACCOUNT_STATEMENT_INDICATOR = gql`
  mutation deleteAccountStatementIndicator($input: DeleteAccountStatementIndicatorItemInput) {
    deleteAccountStatementIndicator(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DUPLICATE_ACCOUNT_STATEMENT = gql`
  mutation duplicateAccountStatement($configId: Int!) {
    duplicateAccountStatement(configId: $configId) {
      commandId
      correlationId
    }
  }
`;